import { Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";

type Props = {
    isNight?: boolean
}
export const RainEffect = ({ isNight }: Props) => {
        const [isSplatActive, setIsSplatActive] = useState(true);
        const [isBackRowActive, setIsBackRowActive] = useState(true);
        const [isSingleToggleActive, setIsSingleToggleActive] = useState(true);
      
        const makeItRain = () => {
          const frontRow = document.querySelector('.rain.front-row');
          const backRow = document.querySelector('.rain.back-row');
      
          if (frontRow) frontRow.innerHTML = '';
          if (backRow) backRow.innerHTML = '';
      
          let increment = 0;
          let drops = '';
          let backDrops = '';
      
          while (increment < 100) {
            const randoHundo = Math.floor(Math.random() * 98) + 1;
            const randoFiver = Math.floor(Math.random() * 4) + 2;
            increment += randoFiver;
      
            drops += `
              <div class="drop" style="left: ${increment}%; bottom: ${randoFiver * 2 + 99}%; animation-delay: 0.${randoHundo}s; animation-duration: 0.5${randoHundo}s;">
                <div class="stem" style="animation-delay: 0.${randoHundo}s; animation-duration: 0.5${randoHundo}s;"></div>
                <div class="splat" style="animation-delay: 0.${randoHundo}s; animation-duration: 0.5${randoHundo}s;"></div>
              </div>`;
            backDrops += `
              <div class="drop" style="right: ${increment}%; bottom: ${randoFiver * 2 + 99}%; animation-delay: 0.${randoHundo}s; animation-duration: 0.5${randoHundo}s;">
                <div class="stem" style="animation-delay: 0.${randoHundo}s; animation-duration: 0.5${randoHundo}s;"></div>
                <div class="splat" style="animation-delay: 0.${randoHundo}s; animation-duration: 0.5${randoHundo}s;"></div>
              </div>`;
          }
      
          if (frontRow) frontRow.innerHTML = drops;
          if (backRow) backRow.innerHTML = backDrops;
        };
      
        useEffect(() => {
          makeItRain();
        }, []);
      
        return (
            <Flex
                position="absolute"
                top="0"
                left="0"
                w="full"
                h="full"
                zIndex={1}
            >
            <div className={`rain-container ${isNight?" isNight ":" "} ${isSplatActive ? 'splat-active' : ''} ${isBackRowActive ? 'back-row-toggle' : ''} ${isSingleToggleActive ? 'single-toggle' : ''}`}>
                <div className="rain front-row"></div>
                <div className="rain back-row"></div>
            </div>
          </Flex>
        );
      };